/*
 * Helpers will be available in the hogan templates (e.g. `snippets/algolia_product_autocomplete.hogan.liquid`)
 * These are Mustache lambdas, so you can call them like this in your templates:
 *
 *     [[# lambda ]][[/ lambda]]
 *
 * In a lambda, `this` is the object passed as a parameter to hogan.
 * (In `snippets/algolia_product_autocomplete.hogan.liquid` for example, `this` will be the product object
 * returned by Algolia.
 *
 * You can also use one parameter with your lambda: the text contained in it.
 *
 * ------------------------------------------------------------------------------------------------------------
 *
 * __Simple example__:
 * Let's first define a lambda:
 *
 *     algolia.helpers = {
 *       printer: function (text, render) {
 *         return render(text);
 *       }
 *     };
 *
 * Rendering the template
 *
 *     [[# helpers.lambda ]]2[[/ helpers.lambda]]
 *
 * Called with
 *
 *     {
 *       helpers: algolia.helpers
 *     }
 *
 * Will just output: `2`.
 *
 * ------------------------------------------------------------------------------------------------------------
 *
 * __More complex example__:
 *
 *     algolia.helpers = {
 *       image_tag: function (text, render) {
 *         return '<img src="' + render(text) + '" alt="' + this.default_alt + '" />';
 *       }
 *     }
 *
 * Rendering the template
 *
 *     [[# helpers.image_tag ]][[image]][[/ helpers.image_tag ]]
 *
 * Called with
 *
 *     {
 *       image: 'https://www.google.com/images/srpr/logo11w.png',
 *       default_alt: 'Image',
 *       helpers: window.algolia.helpers
 *     }
 *
 * Will output:
 *
 *     <img src="https://www.google.com/images/srpr/logo11w.png" alt="Image" />
 *
 */

(function (algolia) {
  'use strict';

  var _ = algolia._;

  var formatPrice = function formatPrice (value) {
    return algolia.formatMoney(+value * 100, '$\{\{ amount \}\}');
  };

  algolia.helpers = {
    /* For a product with price = 90$ and compare_at_price = 100$
     * Outputs: `$90 $̶1̶0̶0̶ -10%`
     */
    formattedPriceWithComparison: function formattedPriceWithComparison () {
      var comparing = +this.compare_at_price && +this.compare_at_price > +this.price,
          discount_ratio = 1.0 - this.price_ratio,
          res = '<span class="price-news">' + formatPrice(this.price) + '</span>';
      if (comparing) {
        res += '<div class="price-msrp-sale">';
        res += '<del>' + formatPrice(this.compare_at_price) + '</del>';
        res += '<span class="pt-price">' + Math.floor(discount_ratio * 100) + '% Off!</span>';
        res += '</div>';
      }

      return res;
    },
    formattedCompareAtPrice: function formattedCompareAtPrice() {
      return formatPrice(this.compare_at_price);
    },
    /* Takes a number as a parameter and returns it formatted with currency
     * `[[# helpers.formattedPrice ]]200[[/ helpers.formattedPrice ]]`
     * Outputs `$200` if it's how it in configured in Shopify
     */
    formattedPrice: function formattedPrice (text, render) {
      return formatPrice(render(text));
    },
    /* Takes a number as a parameter, applies `formattedPrice` on it but removes
     * the decimals
     * `[[# helpers.formattedPrice ]]200.34[[/ helpers.formattedPrice ]]`
     * Outputs `$200` depending on Shopify configuration
     */
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals (text, render) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    /* For an iPhone with color and disk size information
     * Outputs : iPhone (Blue / 16G)
     */
    fullTitle: function fullTitle () {
      var res = this._highlightResult.title.value.replace(/"/g,'&quot;');
      if (this.variant_title && this.variant_title !== 'Default Title') {
        res += ' <span class="algolia-variant">(' + this._highlightResult.variant_title.value.replace(/"/g,'&quot;') + ')</span>';
      }

      return res;
    },
    /* Applies Math.floor to the number passed as an argument
     * `[[# helpers.floor ]][[ price ]][[/helpers.floor ]]`
     * With `price = 2.43`
     * Outputs `2`
     */
    floor: function floor (text, render) {
      return '' + Math.floor(+render(text));
    },
    /* Applies Math.ceil to the number passed as an argument
     * `[[# helpers.ceil ]][[ price ]][[/helpers.ceil ]]`
     * With `price = 2.43`
     * Outputs `3`
     */
    ceil: function ceil (text, render) {
      return '' + Math.ceil(+render(text));
    },
    brandImageClass: function brandClass() {
      if (typeof this.meta.model_info !== 'undefined') {
      	return this.meta.model_info.brand.replace(' ', '-').toLowerCase();
      }  else {
        return 'undefined';
      }
  	},
    brand: function brand() {
      if (typeof this.meta.model_info !== 'undefined') {
      	return this.meta.model_info.brand;
      }  else {
        return 'Coming Soon!';
      }
    },
    displayTitle: function displayTitle() {
      if (typeof this.meta.model_info !== 'undefined') {
      	return this.meta.model_info.display_title;
      } else {
        return 'Coming Soon!';
      }
    },
    displayModel: function model() {
      if (typeof this.meta.model_info !== 'undefined') {
      	return this.meta.model_info.display_model;
      }
    },
    productStickerImage: function productStickerImage() {
      var img = '';
      if (this.tags.indexOf('Scratch & Dent') > 0) {
        img = 'https://cdn.shopify.com/s/files/1/0824/6953/t/9/assets/scratch-dent.png';
      } else if (this.tags.indexOf('DH Kitted') > 0) {
        img = 'https://cdn.shopify.com/s/files/1/0824/6953/t/9/assets/dh-kit.png'; /*?2784067160765629294';*/
      } else if (this.tags.indexOf('Bundles') > 0) {
        img = 'https://cdn.shopify.com/s/files/1/0824/6953/t/9/assets/dh-bundle.png'; /* ?2784067160765629294';*/
      } else if (this.tags.indexOf('Free Shipping') > 0) {
        img = 'https://cdn.shopify.com/s/files/1/0824/6953/t/9/assets/freeshipping.png';
      }
      return img;
    },
    productStickerTitle: function productStickerTitle() {
      var title = '';
      if (this.tags.indexOf('Scratch & Dent') > 0) {
        title = 'Scratch & Dent';
      } else if (this.tags.indexOf('DH Kitted') > 0) {
        title = 'DH Kitted';
      } else if (this.tags.indexOf('Bundles') > 0) {
        title = 'Bundles';
      } else if (this.tags.indexOf('Free Shipping') > 0) {
        title = 'Free Shipping';
      }
      return title;
    },
    productStickerStyle: function productStickerStyle() {
      var style = '';
      if (this.tags.indexOf('DH Kitted') < 0 && this.tags.indexOf('Scratch & Dent') < 0 && this.tags.indexOf('Free Shipping') < 0 && this.tags.indexOf('Bundles') < 0) {
        style = 'display:none;';
      } else if (this.tags.indexOf('DH Kitted') >= 0 || this.tags.indexOf('Bundles') >= 0) {
        style = 'width: 100px;';
      }
      return style;
    },
    productSaleStickerImage: function productSaleStickerImage() {
      var img = '';
      if (this.tags.indexOf('On Sale') > 0) {
        img = 'https://cdn.shopify.com/s/files/1/0824/6953/t/9/assets/onsale.png';
      }
      return img;
    },
    productSaleStickerTitle: function productSaleStickerTitle() {
      var title = '';
      if (this.tags.indexOf('On Sale') > 0) {
        title = 'On Sale';
      }
      return title;
    },
    productSaleStickerStyle: function productSaleStickerStyle() {
      var style = '';
      if (this.tags.indexOf('On Sale') > 0) {
        style = 'right:5px; width:60px;';
      } else {
        style = 'display:none;';
      }
      return style;
    },
    productDescription: function productDescription() {
      return this.body_html_safe.replace(new RegExp("\"", "g"), "&quot;");
    },
    productTags: function productTags() {
      return this.tags.join(',');
    },
    getAddToCartOrSoldOut: function getAddToCartOrSoldOut() {
      var html = '';
      if (this.inventory_quantity > 0) {
        if (this.inventory_quantity <= 5) {
          html = '<p style="clear:both;"><span class="red">Only ' + this.inventory_quantity + ' left in stock - order soon.</span></p>';
        } else {
          html = '<p>&nbsp;</p>';
        }
      	html = html + '<form id="add-item-form-' + this.objectID + '" action="/cart/add" method="post" class="variants clearfix"><input type="hidden" name="id" value="' + this.objectID + '" /><input type="hidden" name="name-cart" class="name-cart" value="' + this.meta.model_info.display_title.replace(/"/g,'&quot;') + '"><input type="hidden" name="img" class="image-cart" value=""><input type="submit" value="Add to Cart" class="btn btn-cart addtocart" /></form>';
        if (this.tags.indexOf('JIT GP') > 0 || this.tags.indexOf('Rollers') > 0) {
          html = html + '<p>ORDER BY 10AM CT &amp; <span class="red">SHIPS IN 1 BUSINESS DAY</span></p>';
        } else {
          html = html + '<p>ORDER BY 2PM CT FOR <span class="red">SAME DAY SHIPPING</span></p>';
        }
      } else {
        html = '<span class="product-sold-out">Sold Out</span><br /><input type="button" class="BIS_trigger btn btn-email-when-available" value="Email when available" data-product-handle="' + this.handle + '">';
      }
      return html;
    },
    getProductDetailsInnerContainerPadding: function getProductDetailsInnerContainerPadding() {
      var padding = "25px 0 10px 0;";
      
      if (!this.available) {
        padding = "17px 0 10px 0;";
      }
      return padding;
    },
    getCartNameText: function getCartNameText() {
      return this.title;
    },
    getCartImageSrc: function getCartImageSrc() {
      //www.dollarhobbyz.com/cdn/shop/t/9/assets/No_Image_2.png?v=182937067370129095241517422055
      var imgSrc = '';
    }
  };

  /* Image size helpers
   *
   * Here we create the following helpers:
   * - `picoImage`
   * - `iconImage`
   * - `thumbImage`
   * - `smallImage`
   * - `compactImage`
   * - `mediumImage`
   * - `largeImage`
   * - `grandeImage`
   * - `originalImage`
   * These helpers only return the url of the image.
   */
  _.forEach(['pico', 'icon', 'thumb', 'small', 'compact', 'medium', 'large', 'grande', 'original'], function (size) {
    algolia.helpers[size + 'Image'] = (function (_size) {
      return function () {
        if (!this.image) {
          return '';
        }
        if (_size === 'original') {
          return this.image;
        }
        return this.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });
}(algoliaShopify));
